import { Addon } from "./types";

export const ADDONS: Addon[] = [
  {
    id: "jugl::users",
    name: "Extra Team Members",
    description: "Manage team size to fit your needs",
    type: "quantity",
    price: 25,
    billing: "monthly",
    badge: "seats",
    unitLabel: "per member / month",
  },
  {
    id: "jugl::ai_credits",
    name: "Extra message credits",
    description: "Additional 1,000 monthly message credits for AI Agent",
    type: "quantity",
    price: 15,
    billing: "monthly",
    badge: "feature",
    unitLabel: "per 1000 monthly credits / month",
  },
];

export const HIDDEN_ADDON_IDS = ["jugl::ai_credits"];
